export { default as DatadogInit } from './Datadog'
